// extracted by mini-css-extract-plugin
export default {"body":"KJIHhnhfwau3L4PFR6vF","stretch":"G5YlYB_dzdecFMNFTqHi"};